import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col } from "react-bootstrap";

const UnderConstruction = () => {
  const navigate = useNavigate(); // For navigation

  return (
    <div
      className="d-flex justify-content-center align-items-center bg-light"
      style={{
        minHeight: "100vh",
      }}
    >
      <Container className="text-center">
        <Row className="d-flex justify-content-center">
          <Col>
            <div className="mb-4">
              <i
                className="fa fa-tools text-primary"
                style={{ fontSize: "60px" }}
              />
            </div>
            <h1 className="display-4 text-primary">Under Construction</h1>
            <p className="lead text-muted">
              We're working hard to get this page ready. Please check back soon!
            </p>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button
                variant="secondary"
                size="lg"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
              <Button
                variant="primary"
                onClick={() => navigate("/home")}
                size="lg"
              >
                Go to Home
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UnderConstruction;
